import React from 'react';
import type { LearnerAccount } from '../../../accounts';
interface ChildSelectorBarProps {
  linkedLearners: Pick<LearnerAccount, 'id' | 'displayName'>[];
  selectedChildId: string;
  onSelect: (learnerId: string) => void;
}
export function ChildSelectorBar({
  linkedLearners,
  selectedChildId,
  onSelect
}: ChildSelectorBarProps) {
  if (linkedLearners.length <= 1) return null;
  return <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-5336">
      {linkedLearners.map(learner => {
      const initial = learner.displayName.charAt(0).toUpperCase();
      const isSelected = selectedChildId === learner.id;
      return <button key={learner.id} onClick={() => onSelect(learner.id)} className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-bold whitespace-nowrap transition-all ${isSelected ? 'bg-emerald-600 text-white shadow-sm' : 'bg-white text-slate-600 hover:bg-slate-50 border border-slate-200'}`} data-id="element-5337">
            <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-black ${isSelected ? 'bg-white/20 text-white' : 'bg-emerald-50 text-emerald-600'}`} data-id="element-5338">
              {initial}
            </div>
            {learner.displayName}
          </button>;
    })}
    </div>;
}